function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": 1
}, React.createElement("g", {
  "data-name": "mail--color copy 2"
}, React.createElement("path", {
  fill: "#e6ae45",
  d: "M26.46 0L0 12.22l26.46 22.53 26.45-22.53L26.46 0z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M4.45 10.55h43.41v20.64H4.45z"
}), React.createElement("path", {
  fill: "#f7cf80",
  d: "M26.46 27.53L0 12.22v33.71h52.91V12.22L26.46 27.53z"
}), React.createElement("circle", {
  fill: "#de5b6b",
  cx: 51.46,
  cy: 46.16,
  r: 9.19
}), React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M51.46 40.02v8.06m0 1.44v2.87"
}))));

var SvgIconMailExpired = function SvgIconMailExpired(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 60.65 55.35",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconMailExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-mail--expired.e40127a1.svg";
export { ForwardRef as ReactComponent };